import { ELocalStorageKey } from '../types/enums'
import request, { IWorkspaceResponse } from '/@/api/http/request'
import { mapLayers } from '/@/constants/mock-layers'
import { elementGroupsReq, PostElementsBody, PutElementsBody } from '/@/types/mapLayer'
const PREFIX = '/map/api/v1'

/** 获取当前 workspace_id（实时从 localStorage 读取） */
function getWorkspaceId () {
  return localStorage.getItem(ELocalStorageKey.WorkspaceId)
}

type UnknownResponse = Promise<IWorkspaceResponse<unknown>>
// get elements group
// export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
//   const url = `${PREFIX}/workspaces/${getWorkspaceId()}/element_groups`
//   const result = await request.get(url, {
//     params: {
//       group_id: reqParams.groupId,
//       is_distributed: reqParams.isDistributed
//     },
//   })
//   return result.data
// }
export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
  return mapLayers
}

// Get elements groups request
export const getElementGroupsReq = async (params: elementGroupsReq): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + '/element-groups'
  const result = await request.get(url, {
    params: params
  })
  return result.data
}
// Get element group elements request
// add
export const addGroup = async (body: object): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + '/groups'
  const result = await request.post(url, body)
  return result.data
}
// edit
export const editGroup = async (pid: string, body: object): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + `/groups/${pid}`
  const result = await request.put(url, body)
  return result.data
}
// delete
export const deleteGroup = async (pid: string): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + `/groups/${pid}`
  const result = await request.delete(url)
  return result.data
}
// add element
export const postElementsReq = async (pid: string, body: PostElementsBody): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + `/element-groups/${pid}/elements`
  const result = await request.post(url, body)
  return result.data
}
export const addRoi = async (body: object): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = '/manage/api/v1/roi/add'
  const result = await request.post(url, body)
  return result.data
}
export const updateRoi = async (body: object): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = '/manage/api/v1/roi/update'
  const result = await request.post(url, body)
  return result.data
}
export const listByFlyLineFileId = async (fly_line_file_id: string, workspace_id: string): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `/manage/api/v1/roi/listByFlyLineFileId/${fly_line_file_id}/${workspace_id}`
  const result = await request.post(url)
  return result.data
}
// Update map element request
export const updateElementsReq = async (id: string, body: PutElementsBody): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + `/elements/${id}`
  const result = await request.put(url, body)
  return result.data
}
// Delete map element
export const deleteElementReq = async (id: string, body: {}): Promise<any> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + `/elements/${id}`
  const result = await request.delete(url, body)
  return result.data
}

// Delete layer elements
export const deleteLayerEleReq = async (id: string, body: {}): Promise<any> => {
  const url = `${PREFIX}/workspaces/` + getWorkspaceId() + `/element-groups/${id}/elements`
  const result = await request.delete(url, body)
  return result.data
}
